import {
    COSTRATE_LOADING, GET_COSTRATE_DATA_SUCCESS,
    GET_COSTRATE_DATA_ERROR, COSTRATE_END_LOADING, RESET_COSTRATE
} from "../actions/actionCostRate";

const initialState = {
    costrate: {},
    loading: false,
    costraterror: ''
};

function reducerCostRate(state = initialState, action) {

    switch (action.type) {
        case COSTRATE_LOADING: {
            return {
                ...state,
                loading: true,
                costraterror: ''
            };
        }

        case GET_COSTRATE_DATA_SUCCESS: {

            return {
                ...state,
                loading: false,
                costrate: action.payload.length > 0 ? action.payload[0] : null,
                costraterror: ''
            };
        }


        case GET_COSTRATE_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                costrate: {},
                costraterror: action.error
            }
        }

        case COSTRATE_END_LOADING: {
            return {
                ...state,
                loading: false
            }
        }

        case RESET_COSTRATE: {
            return {
                ...state,
                costrate: {},
                loading: false,
                costraterror: ''
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerCostRate;